/* eslint-disable max-statements */
import {AxiosPromise} from 'axios';
import FormData from 'form-data';

import {ActionType} from '@typescript/common/actionTypes';
import {NEWSLETTER} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

export type SubscribeActionType = (
    email: string,
    {
        from,
        affId,
        verifyRealEmail,
        subscriptionMethod,
        state,
        country,
    }: {
        from?: string;
        affId?: string;
        verifyRealEmail?: boolean;
        subscriptionMethod?: 'Auto' | 'Manual';
        state?: string;
        country?: string;
    },
) => ActionType<AxiosPromise>;

/**
 * Subscribe a customer
 * @param {string} email Email for subscription
 * @param {{from: string, affId: string, verifyRealEmail: boolean}} parameters - Additional arguments
 * @returns {ActionType<AxiosPromise>} Action
 */
export function subscribe(
    email: string,
    {
        from = '',
        affId = '',
        verifyRealEmail = false,
        subscriptionMethod = 'Manual',
        state = '',
        country = '',
    } = {},
): ActionType<AxiosPromise> {
    const data = new FormData();
    data.append('ajax', 1);
    data.append('email', email);
    data.append('subscribed_from', from);
    data.append('affid', affId);
    data.append('verify_real_email', Number(verifyRealEmail));
    data.append('subscription_method', subscriptionMethod);
    data.append('client_region_name', state);
    data.append('client_country_name', country);
    return {
        type: NEWSLETTER.SUBSCRIBE,
        payload: instanceGusaBackend({
            headers: {'is-react': '1'},
            method: 'post',
            url: ENDPOINTS.CUSTOMER_SUBSCRIBE_AJAX,
            data,
        }),
        meta: {
            email,
            from,
        },
    };
}

type ReturnDataType = ActionType<
    Promise<{data: {redirect: string}}>,
    {email: string; from: string}
>;
/**
 * Subscribe a customer
 * @namespace
 * @property {string} email - customer email
 * @property {string} from - what form came from
 * @property {string} redirect - redirect path
 * @returns {ReturnDataType} Action
 */
export function receiveSubscribe({email = '', from = '', redirect = ''}): ReturnDataType {
    return {
        type: NEWSLETTER.SUBSCRIBE,
        payload: Promise.resolve({
            data: {
                redirect,
            },
        }),
        meta: {
            email,
            from,
        },
    };
}
